<i18n>
{
  "de": {
    "search": "Suche",
    "filterByMonths": "Monat",
    "selectYearAll": "Jahr auswählen",
    "deselectYearAll": "Jahr abwählen"
  },
  "en": {
    "search": "Search",
    "filterByMonths": "Months",
    "selectYearAll": "Select year",
    "deselectYearAll": "Deselect year"
  }
}
</i18n>

<template>
  <div>
    <section>
      <vue-multi-select
        ref="multiSelectMonths"
        v-model="values"
        class="multi-select filter-month"
        :class="{
          'filter-month-mobile': layout === 'mobileFilterPosts',
          'has-selections': hasSelections
        }"
        :options="options"
        :filters="filters"
        :btnLabel="btnLabel"
        :position="layout === 'mobileFilterPosts' ? '' : 'bottom-left'"
        :searchPlaceholder="`${$t('search')}...`"
        :selectOptions="monthsOptions"
        @selectionChanged="executeFilter"
        @open="open"
      />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'

export default {
  props: ['layout'],
  components: { vueMultiSelect },
  name: 'Filter-Posts-Months',
  data: () => ({
    values: [],
    options: {
      multi: true,
      groups: true,
      labelValue: '_id',
      cssSelected: (option) => option.selected ? { 'font-weight': 'bold', color: '#fb3e52' } : ''
    },
    filters: [{
      nameAll: 'select all',
      nameNotAll: 'unselect all',
      // nameAll: this.selectAllLabel,
      // nameNotAll: this.deselectAllLabel,
      func() {
        return true
      }
    }],
    filterInitialized: false,
    calculatedMonths: [],
    firstOpen: true
  }),
  computed: {
    hasSelections() {
      return this.values && this.values.length > 0
    },
    monthsOptions() {
      if (this.calculatedMonths.length) {
        return this.calculatedMonths
      }
      return this.monthsByYearSince(this.artist.createdAt, this.$i18n.locale)
    },
    ...mapState(['artist', 'postFilter'])
  },
  methods: {
    btnLabel() {
      return this.$t('filterByMonths') + (this.values.length ? ` (${this.values.length})` : '')
    },

    clearResult() {
      this.value = []
    },

    resetFilterUI() {
      this.values = []
      this.filterInitialized = false
    },

    initFilter() {
      this.filters[0].nameAll = this.$t('selectYearAll')
      this.filters[0].nameNotAll = this.$t('deselectYearAll')
    },

    restoreFilter() {
      this.filterInitialized = false
      this.values = []

      if (
        !this.postFilter ||
        !this.postFilter.months ||
        !this.postFilter.months.length
      ) {
        return this.clearResult()
      }

      this.values = this.postFilter.months
      this.filterInitialized = true
    },

    async executeFilter() {
      if (!this.filterInitialized) {
        this.values = this.postFilter.months
        this.filterInitialized = true
        return
      }

      const filter = { months: this.values }
      this.$emit('filter', filter)
    },

    open() {
      this.$root.$emit('closeOtherFilterDropdowns', 'months')
      if (this.firstOpen && this.monthsOptions.length) {
        this.$refs.multiSelectMonths.selectTab(this.monthsOptions.length - 1)
        this.firstOpen = false
      }
    },

    closeDropdown() {
      this.$refs.multiSelectMonths?.closeMultiSelect?.()
    }
  },

  mounted() {
    if (this.artist) {
      this.initFilter()
    }

    this.$root.$on('recoverPostFilter', this.restoreFilter)
    this.$root.$on('resetAllFilters', this.resetFilterUI)
    this.$root.$on('closeOtherFilterDropdowns', (openedBy) => {
      if (openedBy !== 'months') {
        this.closeDropdown()
      }
    })
    this.filterInitialized = true
  },

  beforeDestroy() {
    this.$root.$off('recoverPostFilter', this.restoreFilter)
    this.$root.$off('resetAllFilters', this.resetFilterUI)
    this.$root.$off('closeOtherFilterDropdowns')
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';
@media only screen and (max-width: $mobile-portrait) {
  .filter-month-mobile {
    .checkboxLayer {
      min-width: 186px !important;
      max-width: 186px;
    }
  }
}

@media only screen and (min-width: $mobile-portrait) and (max-width: $mobile) {
  .filter-month-mobile {
    .checkboxLayer {
      min-width: 250px !important;
      max-width: 250px;
    }
  }
}
</style>
